import { actionGenerator, IReduxAction } from '../../../actionGenerator';
import { IPublishInfoError } from '../types';

export const PUBLISH_OFFER_FAIL = 'PUBLISH_OFFER :: FAIL';

export type TPublishOfferFailAction = IReduxAction<typeof PUBLISH_OFFER_FAIL, IPublishInfoError>;

export const publishOfferFail = actionGenerator<typeof PUBLISH_OFFER_FAIL, IPublishInfoError>(PUBLISH_OFFER_FAIL);
